import Vue from '../../node_modules/vue/dist/vue.esm';
import "../scss/article.scss";
import "./common";

const Article = () => import(/* webpackChunkName: "Article" */ './modules/article');
const Header = () => import(/* webpackChunkName: "Header" */'./modules/header');
const Footer = () => import(/* webpackChunkName: "Footer" */'./modules/footer');
const ArticlesMenu = () => import(/* webpackChunkName: "ArticlesMenu" */ './modules/articles-menu');
const ArticlesSubmenu = () => import(/* webpackChunkName: "ArticlesSubmenu" */ './modules/articles-submenu');
const ArticlesAuthorList = () => import(/* webpackChunkName: "ArticlesAuthorList" */ './modules/articles-author-list');

Vue.filter('formatTime', function(value) {
    let sec_num = parseInt(value, 10);
    let hours   = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0" + hours;}
    if (minutes < 10) {minutes = "0" + minutes;}
    if (seconds < 10) {seconds = "0" + seconds;}
    
    if (hours > 0) {
        return hours + ':' + minutes + ':' + seconds;
    }
    return minutes + ':' + seconds;
});

Vue.filter('formatPhone', function (value) {
    if (value.length !== 10) {
        return value;
    }
    return '(' + value.substring(0, 3) + ') ' + value.substring(3, 6) + '-' + value.substring(6, 8) + '-' + value.substring(8, 10);
});

Vue.filter('objectLength', function (value) {
    if (typeof(value) !== 'object') {
        return 0;
    }
    return Object.keys(value).length;
});

Vue.filter('formatCurrency', function (value) {
    value = parseInt(value, 10);

    if (value) {
        return String(value.toFixed(0)).replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ');
    }
    
    return '0';
});

function createVueInstance (id, moduleImport) {
    const el = document.getElementById(id);
    if (el) moduleImport().then(module => new Vue({el: '#' + id, ...module.default}));
}

createVueInstance('header', Header);
createVueInstance('footer', Footer);
createVueInstance('new-article', Article);
createVueInstance('article', Article);
createVueInstance('articles-menu', ArticlesMenu);
createVueInstance('articles-submenu', ArticlesSubmenu);
createVueInstance('author-list-page', ArticlesAuthorList);